export default __webpack_public_path__ + "static/media/17.ed4867b4.png";